import Logo from "../assests/Logo.png"
import appConfig from "../utils/appConfig"

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-extrabold text-black">Refund Policy</h1>
          <div className="mt-2 w-24 h-1 bg-yellow-500 mx-auto"></div>
        </div>

        <div className="bg-white border border-yellow-200 rounded-lg shadow-lg overflow-hidden">
          <div className="p-8">
            <div className="prose prose-lg max-w-none">
              <div className="space-y-6">
                <p className="text-black leading-relaxed">
                <b>At Market Analysis Academy</b>, we strive to ensure customer satisfaction with our services. 
                This Refund Policy outlines the terms and conditions regarding refunds for purchases.
                </p>

                <div>
                  <h2 className="text-xl font-bold text-black mb-2">Subscription / Membership Refunds:</h2>
                  <p className="text-black leading-relaxed">
                  In case of a refund initiation, the client will be entitled to refund of the pending days 
                  left as per the latest SEBI Circular. This will be after taking into consideration the fixed 
                  costs of joining which include client KYC, Validation and E-Signature.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-black mb-2">Pre Booking Refunds:</h2>
                  <p className="text-black leading-relaxed">
                  If you have pre booked or reserved your seat by paying a token amount, 
                  that shall be refundable within 3 days of making the transaction.
                   After 3 days, the pre booking amount will be non refundable.
                   However, this amount can be adjusted towards the final payment of membership / service.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-black mb-2">Refund Requests:</h2>
                  <p className="text-black leading-relaxed">
                    To request a refund, please contact our customer support team over email at{" "}
                    {appConfig.footerText.email}
                    or over WhatsApp on {appConfig.footerText.contactNumber} with details of your purchase and reason
                    for the refund request.
                  </p>
                  <p className="text-black leading-relaxed">
                    Refund requests must be submitted within the specified timeframes mentioned above to be considered
                    for approval.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-black mb-2">Non-Subscription Purchases:</h2>
                  <p className="text-black leading-relaxed">
                    Refunds for one-time purchases shall also be non refundable or non transferable.
                  </p>
                  <p className="text-black leading-relaxed">
                    Please contact us if you are dissatisfied with our services, we will do our best to rectify the same
                    and connect you with our customer support team.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-black mb-2">Refund Processing:</h2>
                  <p className="text-black leading-relaxed">
                    Once your refund request is received and approved, we will process the refund within 7-10 business
                    days.
                  </p>
                  <p className="text-black leading-relaxed">
                    Refunds will be issued to the original payment method used for the purchase or to the bank account
                    as mentioned in their email.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-bold text-black mb-2">Exceptions:</h2>
                  <p className="text-black leading-relaxed">
                    We reserve the right to deny refund requests if we suspect misuse of our services or if the request
                    does not meet our refund criteria.
                  </p>
                  <p className="text-black leading-relaxed">
                    No refunds will be provided for subscription renewals or purchases made outside of the specified
                    refund period.
                  </p>
                </div>
              </div>
            </div>
          </div>

        
          <div className="bg-gray-50 border-t border-yellow-100 px-8 py-6">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between">
              <div className="flex items-center">
                <div className="w-1 h-12 bg-yellow-500 mr-4"></div>
                <p className="text-sm text-gray-600">
                  <span className="block text-black font-semibold">Market Analysis Academy</span>
                  <span className="block mt-1 text-black font-semibold">SEBI Registration No: INH000019804</span>
                </p>
              </div>
              <div className="mt-4 sm:mt-0">
                <div className="text-sm text-gray-600">
                  <p className="block text-black font-semibold">
                    Contact Us:
                    <br />
                    Email: {appConfig.footerText.email || ""}
                    <br />
                    Phone: {appConfig.footerText.contactNumber || ""}
                  </p>
                </div>
              </div>
            </div>
          </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full">
            <img
              src={Logo || "/placeholder.svg"}
              alt="Market Analysis Academy Logo"
              className="w-full h-full object-contain"
            />
          </div>
          <p className="mt-4 text-sm text-gray-500">
            © {new Date().getFullYear()} Market Analysis Academy. All rights reserved.
          </p>
          <div className="mt-1 text-sm text-gray-500 mb-1">
            <p>
              Address: {appConfig.footerText.address || ""}
            </p>
          </div>
        </div>
      </div>
    </div>
    </div>

  );
}
